import vCaptureClick from "./v-captureclick.vue";

export default Vue => {
  Vue.component("v-captureclick", vCaptureClick);
};
